import React from 'react';

import { SimpleAmountSelector } from './components/AmountSelector/SimpleAmountSelector';
import { useImpressionAmountSelector } from './hooks/useImpressionAmountSelector';

export const ImpressionAmountSelector: React.FC = () => {
	const {
		data: { ref },
	} = useImpressionAmountSelector();

	return (
		<div data-testid="promotion-impression-amount-selector" ref={ref}>
			<SimpleAmountSelector />
		</div>
	);
};
